<template>
  <el-table :data="tableArr" border style="width: 100%;" stripe="stripe">
    <el-table-column prop="date" label="" height="68" align="center">
    </el-table-column>
    <el-table-column prop="az" label="安装工" height="68" align="center">
    </el-table-column>
    <el-table-column prop="by" label="搬运工" height="68" align="center">
    </el-table-column>
    <el-table-column prop="wx" label="维修工" height="68" align="center">
    </el-table-column>
    <el-table-column prop="bq" label="补漆工" height="68" align="center">
    </el-table-column>
  </el-table>

</template>

<script>
  export default {
    data() {
      return {
        stripe:false,
        tableArr:[]
      }
    },
    mounted() {
      this.initData()
    },
    methods:{
      initData(){
        debugger
        let that =this
        that.tableArr=[]
        let tableItem={}
        that.workTypeTable.forEach((item)=>{
          tableItem.date=item.workScheduleRuleDate.date,
          item.workTypeNum.forEach((citem)=>{
            tableItem.az=citem[0].value
            tableItem.by=citem[1].value
            tableItem.wx=citem[2].value
            tableItem.bq=citem[3].value
          })
        })
       that.tableArr.push(tableItem)
      }
    },
    props:['workTypeTable'],
  }
</script>

<style>
</style>
